import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import Description from "../../Components/Description?v=0.0.2";
import HighlightText from "../../Components/HighlightText?v=0.0.2";
import EmailTextField from "../../Components/EmailTextField?v=0.0.2";
import * as Constants from "../../Constants?v=0.0.2";

import BackArrow from "../../Images/BackArrow.svg";
import ForgotPasswordPageImage from "../../Images/ForgotPasswordPageImage.svg";

function ForgotPasswordMyPlan(props) {
  document.title = "myPlan | Forgot Password";
  const environment = props.environment;
  const history = useHistory();
  const [emailTFResultLabelFlag, setEmailTFResultLabelFlag] = useState(false);
  const [validEmail, setValidEmail] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [emailTFResultLabel, setEmailTFResultLabel] = useState("");
  const [email, setEmail] = useState("");

  const onEmailTFChange = (email) => {
    setEmailTFResultLabel("");
    setEmail((prevState) => {
      return email;
    });
  };

  const onValidEmailHandler = (currentEmail) => {
    setEmail((prevState) => {
      return currentEmail;
    });
  };

  const changeEmailFlagHandler = (flag, currentEmail) => {
    setEmailTFResultLabelFlag(flag);
    setValidEmail((prevState) => {
      return flag;
    });
    if (!flag) {
      setEmailTFResultLabel((prevState) => {
        return currentEmail === "" ? "" : "Invalid email address.";
      });
    } else {
      setEmailTFResultLabel((prevState) => {
        return "";
      });
    }
  };

  const onValidNumberHandler = (number) => {
    onValidEmailHandler(number);
  };
  const changeNumberFlagHandler = (flag, number) => {
    changeEmailFlagHandler(flag, number);
  };

  const ContinueToStep2 = (event) => {
    if (email.length === 0) {
      setEmailTFResultLabel("*Enter an Email.");
      setEmailTFResultLabelFlag(false);
    }
    if (validEmail) {
      setShowLoader(true);
      fetch(environment.myPlanLoginAppAPI + Constants.forgotPassword, {
        method: "POST",
        body: JSON.stringify({
          User: { emailAddress: email },
        }),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then(
          (result) => {
            setShowLoader(false);
            if (result.dataStatus.isSuccess) {
              props.showToast(result.dataStatus.message);
            } else {
              setEmailTFResultLabel(result.dataStatus.message);
              setEmailTFResultLabelFlag(false);
            }
          },
          (error) => {
            console.log(error);
          }
        );
    }
  };

  return (
    <div className="App col-12 d-flex align-items-center myPlan">
      <div className="container custom-container">
        <div className="row flex-direction-col-reverse content-box m-4 m-lg-0">
          <div className="col-lg-6 d-none d-lg-flex align-items-center justify-content-lg-start justify-content-center description-box position-relative">
            <div className="d-flex flex-column margin-interaction-card">
              <div className="d-flex flex-wrap align-items-center">
                <button
                  className="clean-button px-3"
                  onClick={() => {
                    history.push("/myPlan/login");
                  }}
                >
                  <img src={BackArrow} alt=""></img>
                </button>
                <div>
                  <div className="font-20-600">Forgot your Password?</div>
                  <Description
                    className="description"
                    text="Help us to find your account."
                  ></Description>
                </div>
              </div>
              <img
                src={ForgotPasswordPageImage}
                alt=""
                className="forget-password-image mt-3"
              />

              <div className="padding-top d-block">
                <HighlightText
                  className="grey text-align-left font-12-400 center-on-medium-devices"
                  subClassName="blue underline"
                  text1="Need Help ? We are just a click away"
                  text2=""
                  subText="Contact us"
                  hasHyperLink={true}
                  hyperLink="https://www.zetran.com/contact-us/"
                ></HighlightText>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 d-lg-flex d-block align-items-center">
            <div className="mx-auto mx-lg-0 interaction-card">
              <div className="d-flex flex-wrap justify-content-center py-lg-3">
                <img
                  src="https://cdn.zetran.com/assets-mybooks/accounts-portal/myPlan_logo_Black.png"
                  alt=""
                  className="logo-image"
                />
              </div>
              <div className="font-20-600 d-lg-none b-block my-3">
                Forgot your Password?
              </div>
              <div className="mt-5 mb-3">
                <label className="label">Enter your registered Email ID</label>
                <EmailTextField
                  className={`${email !== "" ? "value-entered" : ""}`}
                  value={email}
                  onChange={onEmailTFChange}
                  onValidEmail={onValidEmailHandler}
                  changeEmailFlag={changeEmailFlagHandler}
                  onValidNumber={onValidNumberHandler}
                  changeNumberFlag={changeNumberFlagHandler}
                  isSignUp={true}
                  dontShowNumberLabel={true}
                  hasPlaceHolder={true}
                  placeholder="Email ID"
                ></EmailTextField>
                {emailTFResultLabel.length !== 0 && (
                  <label
                    className={`result-label ${
                      emailTFResultLabelFlag ? "valid-label" : ""
                    }`}
                  >
                    {emailTFResultLabel}
                  </label>
                )}
              </div>
              <div className="font-12-400 grey">
                We will send you a password reset link.
              </div>
              <button
                className="button d-flex flex-wrap align-items-center justify-content-center mt-5"
                onClick={ContinueToStep2}
              >
                {!showLoader && (
                  <>
                    <div className="mr-2">Send Reset Link</div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      id="Outline"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                    >
                      <path
                        fill="#fff"
                        d="M18,12h0a2,2,0,0,0-.59-1.4l-4.29-4.3a1,1,0,0,0-1.41,0,1,1,0,0,0,0,1.42L15,11H5a1,1,0,0,0,0,2H15l-3.29,3.29a1,1,0,0,0,1.41,1.42l4.29-4.3A2,2,0,0,0,18,12Z"
                      />
                    </svg>
                  </>
                )}
                {showLoader && (
                  <div className="spinner-border" role="status"></div>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordMyPlan;
